import React from "react";
import PropTypes from "prop-types";
import { format } from "date-fns";

import Link from "../common/Link";
import style from "./ArticleCard.module.css";

const ArticleCard = ({ article }) => (
  <Link key={article.path} className={style.root} to={article.path}>
    <div className={style.title}>{article.title}</div>
    <div className={style.description}>{article.subtitle}</div>
    <div className={style.date}>{format(article.date, `MMMM Do, YYYY`)}</div>
  </Link>
);
ArticleCard.propTypes = {
  article: PropTypes.shape({
    path: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    date: PropTypes.any
  }).isRequired
};
export default ArticleCard;



// WEBPACK FOOTER //
// ./src/components/article/ArticleCard.js